<div class="container">
    <div class="row header">
        <div mat-dialog-title class="col-10">
            {{'opcodeServiceManagement.setupOtherServiceOpcode' | translate}}
        </div>
        <div class="col-2 icon d-flex justify-content-end" (click)="close()">
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<div class="container-fluid">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-md-12">
                <div class="font-weight-bold pl-1">{{'opcodeServiceManagement.otherServiceOpcode' | translate}}</div>
                <mat-form-field class="w-100" appearance="outline">
                    <input type="text" matInput formControlName="opcode">
                    <mat-error>{{'opcodeServiceManagement.opcodeIsRequired' | translate}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-12">
                <label class="font-weight-bold pl-1">{{'opcodeServiceManagement.otherServiceDescription' | translate}}</label>
                <mat-form-field class="no-fixed-height w-100" appearance="outline">
                    <textarea rows="3" matInput formControlName="description" maxlength="250"></textarea>
                    <mat-error>{{'opcodeServiceManagement.descriptionIsRequired' | translate}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-md-12">
            <div class="action-con mb-3">
                <div>
                    <button class="action-ok-btn" [disabled]="!form.valid" (click)="saveOtherServiceOpcode()">
                        <span>{{ 'overrideCapacity.save' | translate }}</span>
                    </button>
                </div>
                <div>
                    <button class="action-cancel-btn" (click)="close()">
                        <span>{{ 'overrideCapacity.cancel' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>